// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1gLWs","calendarButtons":"ClockData_calendarButtons__33B3Y"};